import { Delete } from '@mui/icons-material';
import StarIcon from '@mui/icons-material/Star';
import { Box, IconButton, Switch } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import SearchBar from '../../components/SearchBar';
import TableComponent from '../../components/TableComponent';
import { showError, showToast } from '../../constants/toasts';
import MainContainer from '../../layout/MainContainer';
import { RatingModal } from '../../Modals';
import { ConfirmationModal } from '../../Modals/confirmationModal';
import {
  useDeleteRatingByIdMutation,
  useLazyGetRatingQuery,
  useUpdateRatingMutation,
} from '../../service/rating';
import { CommonBody, Rating } from '../../types/General';
import { generateEncryptedKeyBody } from '../../utils/crypto';
import { isValidInput } from '../../utils/validations';

const RatingsAndReviews = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');
  const [openDetail, setOpenDetail] = useState(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>('');
  const [page, setPage] = useState<number>(1);
  const [count, setCount] = useState<number>(0);
  const [rating, setRating] = useState<Rating[]>([]);
  const [hidden, setHidden] = useState<string[]>([]);
  const [open, setOpen] = useState<boolean>(false);
  const [selectedId, setSelectedId] = useState<string>('');
  const [deleteById] = useDeleteRatingByIdMutation();
  const [update] = useUpdateRatingMutation();
  const [loading, setLoading] = useState<boolean>(false);
  const [getRating] = useLazyGetRatingQuery();
  // const
  const [anchorEl1, setAnchorEl1] = React.useState<null | HTMLElement>(null);

  const totalPages = Math.ceil(count / 10);

  const onPageChange = (e: any, newPage: number) => {
    setPage(newPage + 1);
  };

  const handleDelete = async () => {
    setLoading(true);
    try {
      const response = await deleteById({
        id: selectedId,
      }).unwrap();
      setLoading(false);

      if (response?.statusCode === 200) {
        showToast('Deleted successfully');
        getRatingList();
      }
    } catch (error: any) {
      showError(error?.data?.message || '');
      setLoading(false);
    }
  };

  const handleStatusUpdate = async (id: string, status: any) => {
    const body = {
      isBlocked: !status,
    };

    try {
      const encryptedBody = generateEncryptedKeyBody(body) as CommonBody;
      const response = await update({
        body: encryptedBody,
        id: id,
      }).unwrap();
      if (response?.statusCode === 200) {
        const updatedData = rating?.map((item) => {
          if (item?._id === id) {
            return {
              ...item,
              isBlocked: !status,
            };
          }
          return item;
        });
        setRating(updatedData);
        // getRatingList()
        if (!status === true) {
          showToast('Rating blocked successfully');
        } else {
          showToast('Rating unblocked successfully');
        }
      } else {
        showError('Please try again');
      }
    } catch (error: any) {
      console.error(error, 'errror');
      showError(error?.data?.message || '');
    }
  };

  const getRatingList = async () => {
    setIsLoading(true);

    try {
      const body = {
        page,
        length: 10,
      };
      const res = await getRating({
        page,
        limit: 10,
        search: debouncedSearchTerm,
      }).unwrap();
      if (res?.statusCode === 200) {
        setRating(res?.data?.data || []);
        setCount(res?.data?.count);
      } else {
        setRating([]);
      }
    } catch (error: any) {
      showError(error?.data?.message || '');
    }
    setIsLoading(false);
    // ref?.current?.complete();
  };

  useEffect(() => {
    getRatingList();
  }, [debouncedSearchTerm, page]);

  const handleClose = () => {
    setOpenDetail(false);
  };

  const open1 = Boolean(anchorEl1);

  const handleClick1 = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl1(event.currentTarget);
  };
  const handleClose1 = () => {
    setAnchorEl1(null);
  };
  const label = { inputProps: { 'aria-label': 'Switch demo' } };

  const rows = [
    {
      id: 1,
      image: '/static/images/blog_image.jpg',
      title: '10 Essential Tips for Buying a Used Car Like a Pro',
      category: 'Car Maintenance',
      authorName: 'Bella',
      authorImage: '/static/images/profile_attachment.jpg',
      publishDate: '22-10-2024',
    },
    {
      id: 2,
      image: '/static/images/blog_image.jpg',
      title: '10 Essential Tips for Buying a Used Car Like a Pro',
      category: 'Car Maintenance',
      authorName: 'Bella',
      authorImage: '/static/images/profile_attachment.jpg',
      publishDate: '22-10-2024',
    },
    {
      id: 3,
      image: '/static/images/blog_image.jpg',
      title: '10 Essential Tips for Buying a Used Car Like a Pro',
      category: 'Buying Tips',
      authorName: 'Bella',
      authorImage: '/static/images/profile_attachment.jpg',
      publishDate: '22-10-2024',
    },
    {
      id: 4,
      image: '/static/images/blog_image.jpg',
      title: '10 Essential Tips for Buying a Used Car Like a Pro',
      category: 'Buying Tips',
      authorName: 'Bella',
      authorImage: '/static/images/profile_attachment.jpg',
      publishDate: '22-10-2024',
    },
    {
      id: 5,
      image: '/static/images/blog_image.jpg',
      title: '10 Essential Tips for Buying a Used Car Like a Pro',
      category: 'Car Maintenance',
      authorName: 'Bella',
      authorImage: '/static/images/profile_attachment.jpg',
      publishDate: '22-10-2024',
    },
  ];

  const columns: GridColDef<(typeof rating)[number]>[] = [
    {
      flex: 0.8,
      minWidth: 250,
      field: 'seller',
      headerName: 'Seller Details',
      editable: false,
      sortable: false,

      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <figure>
              <img src={row?.sellerImage || '/static/images/user_attachment.jpg'} alt="" />
            </figure>
            <p>
              <b>{row?.sellerName}</b> {row?.sellerDialCode}
              {row?.sellerPhoneNo} <br />
              {row?.sellerEmail}
            </p>
          </div>
        );
      },
    },

    {
      flex: 0.8,
      minWidth: 250,
      field: 'user',
      headerName: 'User Details',
      editable: false,
      sortable: false,

      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            {/* <figure>
              <img
                src={row?.image[0] || "/static/images/user_attachment.jpg"}
                alt=""
              />
            </figure> */}
            <p>
              <b>{row?.userName}</b> {row?.userDialCode}
              {row?.userPhoneNo} <br />
              {row?.userEmail}
            </p>
          </div>
        );
      },
    },

    {
      flex: 0.8,
      minWidth: 200,
      field: 'title',
      headerName: 'Vehicle name',
      editable: false,
      sortable: false,

      renderCell: ({ row }) => {
        return <p>{row?.title || '-'}</p>;
      },
    },
    {
      flex: 0.8,
      minWidth: 200,
      field: 'cover',
      headerName: 'Cover Image',
      editable: false,
      sortable: false,

      renderCell: ({ row }) => {
        return (
          <div className="sq_image" style={{ marginTop: '16px' }}>
            <figure>
              <img src={row?.coverImage || '-'} alt="" />
            </figure>
          </div>
        );
      },
    },
    {
      flex: 1,
      minWidth: 150,
      field: 'Rating',
      headerName: 'Rating',
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        const arr = new Array(row?.rating);
        return (
          <div className="star_rating">
            {[...arr].map((item) => (
              <StarIcon className="active" key={item} />
            ))}
          </div>
        );
      },
    },

    {
      flex: 0.1,
      minWidth: 150,
      field: 'isBlocked',
      filterable: false,
      sortable: false,
      headerName: 'Block/Unblock',
      renderCell: ({ row }) => {
        return (
          <Switch
            {...label}
            size="small"
            checked={!row?.isBlocked}
            onChange={() => handleStatusUpdate(row?._id, row?.isBlocked)}
          />
        );
      },
    },

    {
      flex: 0.1,
      minWidth: 80,
      field: 'action',
      headerName: 'Action',
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="table_actions">
            <Box>
              <IconButton
                onClick={() => {
                  setSelectedId(row?._id);
                  setOpen(true);
                }}
              >
                <Delete
                  sx={{
                    color: 'red',
                    ':hover': {
                      color: 'white',
                    },
                  }}
                />
              </IconButton>
            </Box>
          </div>
        );
      },
    },
  ];

  return (
    <MainContainer>
      <div className="main_title">
        <h1> Ratings and Reviews</h1>
        <p>
          <span onClick={() => navigate('/dashboard')}>Dashboard</span> - Ratings and Reviews
        </p>
      </div>

      <div className="cards">
        <Box className="custom_tabs" sx={{ width: '100%' }}>
          <div className="table_header">
            <div className="left_s">
              <Box className="search_box">
                <SearchBar
                  searchTerm={searchTerm}
                  placeholder="Search"
                  setDebouncedSearchTerm={setDebouncedSearchTerm}
                  value={searchTerm}
                  onCross={() => setSearchTerm('')}
                  onChange={(val: any) => {
                    if (isValidInput(val.target.value)) {
                      setSearchTerm(val.target.value);
                    }
                  }}
                />
              </Box>
            </div>
            {/* <div className="right_s">
              <Box>
                <Button
                  className="btn btn_orange"
                  onClick={() => navigate("add")}
                >
                  Add Blog
                </Button>
              </Box>
            </div> */}
          </div>

          {/* <BlogsList rows={rating} columns={columns} hidden={hidden} /> */}
        </Box>

        <div className="sorting_table">
          <TableComponent
            columns={columns}
            rows={rating}
            count={count}
            page={page}
            onPageChange={onPageChange}
            loading={isLoading}
          />
        </div>

        <ConfirmationModal
          text={'Are you sure to delete this rating?'}
          openModal={open}
          setOpenModal={setOpen}
          handleSubmit={() => {
            handleDelete();
          }}
        />

        <RatingModal open={openDetail} setOpen={setOpenDetail} onClose={handleClose} />
        {/* <Pagination
        module={rating}
        page={page}
        setPage={setPage}
        totalCount={count}
        onPageChange={()=>{}}
        totalPages={totalPages}
        /> */}
      </div>
    </MainContainer>
  );
};

export default RatingsAndReviews;
